<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<caass-personselector [AudienceID]="1" *ngIf="SelectMode == 'PersonMode'"></caass-personselector>

<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<div class="selector-body" style="padding: 20px 20px 0px 20px; background-color: #ebebeb">
						<div class="selector-item" style="display: flex">
							<div>
								<label>Select Mode:</label>
							</div>

							<div class="RadioGroup">
								<input
									class="form-control RadioStyle"
									type="radio"
									name="SelectMode"
									[(ngModel)]="SelectMode"
									(ngModelChange)="onSelectModeChange($event)"
									value="PersonMode"
									id="PersonMode"
								/>
								<label class="NoMargin" for="PersonMode">By Person</label>
							</div>

							<div class="RadioGroup">
								<input
									class="form-control RadioStyle"
									type="radio"
									name="SelectMode"
									[(ngModel)]="SelectMode"
									(ngModelChange)="onSelectModeChange($event)"
									value="SchoolMode"
									id="SchoolMode"
								/>
								<label class="NoMargin" for="SchoolMode">By School</label>
							</div>

							<div class="RadioGroup">
								<input
									class="form-control RadioStyle"
									type="radio"
									name="SelectMode"
									[(ngModel)]="SelectMode"
									(ngModelChange)="onSelectModeChange($event)"
									value="AllMode"
									id="AllMode"
								/>
								<label class="NoMargin" for="AllMode">All</label>
							</div>
						</div>
					</div>

					<div class="selector-body" style="padding: 0px 20px 0px 20px; background-color: #ebebeb" *ngIf="SelectMode == 'SchoolMode'">
						<div class="selector-item">
							<div>
								<label>School</label>
							</div>

							<div style="margin-left: 10px">
								<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
								<select
									class="form-control"
									name="SchoolSelector"
									style="font-size: smaller"
									[(ngModel)]="SchoolID"
									(ngModelChange)="onSchoolChange($event)"
								>
									<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">
										[{{ r.SchoolNumber }}] -
										{{ r.SchoolName }}
									</option>
								</select>
							</div>
						</div>
					</div>

					<div class="selector-body" style="padding: 0px 20px 0px 20px; background-color: #ebebeb">
						<div class="selector-item" style="display: flex">
							<div>
								<label>Start Date</label>
							</div>

							<div style="margin-left: 10px">
								<p-calendar
									showIcon="true"
									showButtonBar="true"
									[(ngModel)]="StartDate"
									(ngModelChange)="onStartDateChange($event)"
									name="StartDate"
								></p-calendar>
							</div>
						</div>

						<div class="selector-item" style="display: flex">
							<div>
								<label>End Date</label>
							</div>

							<div style="margin-left: 10px">
								<p-calendar
									showIcon="true"
									showButtonBar="true"
									[(ngModel)]="EndDate"
									(ngModelChange)="onEndDateChange($event)"
									name="EndDate"
								></p-calendar>
							</div>
						</div>
					</div>

					<!--Buttons-->
					<div class="button-body flex">
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 0px"
							(click)="onRefresh()"
						>
							Refresh
						</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button
							[disabled]="SelectMode != 'PersonMode' || SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onAddRelease()"
						>
							Add Release
						</button>
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onEditRelease()"
						>
							Edit Release
						</button>
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onDeleteRelease()"
						>
							Delete Release
						</button>
						<button
							[disabled]="SelectedPerson == undefined || isProcessing == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onPrintReleasePass()"
						>
							Print Release Pass
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstReleaseSchedule"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedReleaseSchedule"
						dataKey="ReleaseScheduleID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--Name-->
								<th>
									<p-columnFilter type="text" field="Name" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--StudentID-->
								<th>
									<p-columnFilter field="StudentID" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterStudentID
												[ngModel]="value"
												[options]="lstStudentID"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--Homeroom-->
								<th>
									<p-columnFilter field="Homeroom" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterHomeroom
												[ngModel]="value"
												[options]="lstHomeroom"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ReleaseTypeDesc-->
								<th>
									<p-columnFilter field="ReleaseTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterReleaseTypeDesc
												[ngModel]="value"
												[options]="lstReleaseTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--StartDateDesc-->
								<th>
									<!-- <p-columnFilter type="text" field="StartDateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--EndDateDesc-->
								<th>
									<!-- <p-columnFilter type="text" field="EndDateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--ReleaseTimeDesc-->
								<th>
									<!-- <p-columnFilter type="text" field="ReleaseTimeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--AdmitTimeDesc-->
								<th>
									<!-- <p-columnFilter type="text" field="AdmitTimeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--Comment-->
								<th>
									<p-columnFilter type="text" field="Comment" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--ExcuseDesc-->
								<th>
									<p-columnFilter field="ExcuseDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterExcuseDesc
												[ngModel]="value"
												[options]="lstExcuseDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="Name">Name<p-sortIcon field="Name"></p-sortIcon></th>
								<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
								<th pSortableColumn="Homeroom">Homeroom<p-sortIcon field="Homeroom"></p-sortIcon></th>
								<th pSortableColumn="ReleaseTypeDesc">Type<p-sortIcon field="ReleaseTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="StartDateDesc">Start Date<p-sortIcon field="StartDateDesc"></p-sortIcon></th>
								<th pSortableColumn="EndDateDesc">End Date<p-sortIcon field="EndDateDesc"></p-sortIcon></th>
								<th pSortableColumn="ReleaseTimeDesc">Release Time<p-sortIcon field="ReleaseTimeDesc"></p-sortIcon></th>
								<th pSortableColumn="AdmitTimeDesc">Admit Time<p-sortIcon field="AdmitTimeDesc"></p-sortIcon></th>
								<th pSortableColumn="Comment">Reason<p-sortIcon field="Comment"></p-sortIcon></th>
								<th pSortableColumn="ExcuseDesc">Excuse<p-sortIcon field="ExcuseDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-ReleaseSchedule>
							<tr [pSelectableRow]="ReleaseSchedule" (dblclick)="onRowDblClick(ReleaseSchedule)">
								<td *ngFor="let col of cols" style="font-weight: bold">
									{{ ReleaseSchedule[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>

				<div *ngIf="isProcessing" class="TopMargin">
					<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
				</div>
			</div>
		</div>
	</div>
</div>
